import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { Toaster } from '@hugendubel/react-basic';
import { WS } from '../ws/WS';
import { WsAddressList } from '../ws/result/WsAddressList';
import { Store } from '../store';

const loadAddresses = (): Promise<void> =>
    WS.listDelivery()
        .then((deliveryAddresses: WsAddressList) => Store.set({ deliveryAddresses }))
        .catch(error => {
            Track.error(
                TRACK_ID('2019-07-31 03:50:23'),
                'Could not load delivery addresses, because: ' + error.message
            );
            Toaster.open({ id: 'error.message.general' });
        });

export const DeliveryService = { loadAddresses };
